import { defineComponent as _defineComponent } from 'vue'
import DotsLoader from '../dots-loader/dots-loader.vue';
import ManageBookingCancelHeader from '../manage-booking-cancel-header/manage-booking-cancel-header.vue';
import StickySidebar from '../sticky-sidebar/sticky-sidebar.vue';
import TicketPreloader from '../ticket-preloader/ticket-preloader.vue';
import SummaryPreloader from '../summary-preloader/summary-preloader.vue';

interface CancelBookingPreloaderProps {
  isCollapsed?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'cancel-booking-preloader',
  props: {
    isCollapsed: { type: Boolean, default: false }
  },
  setup(__props: any) {




return { __sfc: true,DotsLoader, ManageBookingCancelHeader, StickySidebar, TicketPreloader, SummaryPreloader }
}

})